import {
  createBrowserRouter,
  RouterProvider,
  Outlet,
  Navigate,
  useLocation,
} from 'react-router-dom';
import Home from './page/Home';
import Contact from './page/Contact';
import NotFoundPage from './page/NotFoundPage';
import Header from './layouts/header';
import Footer from './layouts/footer';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Copyright from './page/Copyright';
import PrivacyPolicy from './page/PrivacyPolicy';
import TermsOfService from './page/TermsOfService';

const Layout = () => {
  const { pathname } = useLocation();
  return (
    <div>
      <Header pathname={pathname} />
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        pauseOnHover
        draggable
        theme="light"
      />
      <main>
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

const router = createBrowserRouter([
  {
    path: '/',
    element: <Layout />,
    children: [
      { index: true, element: <Home /> },
      { path: 'home', element: <Navigate to="/" replace /> },
    ],
  },
  {
    path: '/contact',
    element: <Layout />,
    children: [{ index: true, element: <Contact /> }],
  },
  {
    path: '/copyright',
    element: <Layout />,
    children: [{ index: true, element: <Copyright /> }],
  },
  {
    path: '/privacypolicy',
    element: <Layout />,
    children: [{ index: true, element: <PrivacyPolicy /> }],
  },
  {
    path: '/terms',
    element: <Layout />,
    children: [{ index: true, element: <TermsOfService /> }],
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
]);

const App: React.FC = () => {
  return <RouterProvider router={router} />;
};

export default App;
